import { SvgIcon, SvgIconProps } from '@mui/material';

const PromotionCampaignIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 22 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M7.31641 15.1843V14.4343H8.06641V15.1843H7.31641ZM2.58358 20.9778C2.29069 21.2707 1.81581 21.2707 1.52292 20.9778C1.23003 20.6849 1.23003 20.21 1.52292 19.9172L2.58358 20.9778ZM6.56641 19.9212V15.1843H8.06641V19.9212H6.56641ZM7.31641 15.9343H2.57956V14.4343H7.31641V15.9343ZM7.84674 15.7147L2.58358 20.9778L1.52292 19.9172L6.78608 14.654L7.84674 15.7147Z'
          fill='currentColor'
        />
        <path
          d='M11 21.5H17C19.2091 21.5 21 19.7091 21 17.5V5.5C21 3.29086 19.2091 1.5 17 1.5H5C2.79086 1.5 1 3.29086 1 5.5V11.5'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M7.31641 7.81567L10.8498 12.9193C11.5034 13.8633 12.8158 14.0645 13.7221 13.3596L15.3964 12.0574C16.1926 11.4381 17.3253 11.5086 18.0385 12.2219L21.0006 15.184'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <circle
          cx='15.7372'
          cy='6.76327'
          r='1.57895'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </svg>
    </SvgIcon>
  );
};

export default PromotionCampaignIcon;
